import { actions } from '../constants/customer_redirect_light_box/actions';
import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';
import CustomerRedirectAnalytics from '../../_modules/google_analytics/customer_redirect';

export const show = () => {
    Dispatcher.handleCustomerRedirectLightBoxAction({ type: actions.SHOW });
    CustomerRedirectAnalytics.showAction();
    return resolvePromise();
};

export const hide = () => {
    Dispatcher.handleCustomerRedirectLightBoxAction({ type: actions.HIDE });
    CustomerRedirectAnalytics.closeAction();
    return resolvePromise();
};

export const redirect = () => {
    Dispatcher.handleCustomerRedirectLightBoxAction({ type: actions.REDIRECT });
    CustomerRedirectAnalytics.redirectAction();
    return resolvePromise();
};
